// 部落格文章資料（發布時從 feis-articles 匯出的靜態快照）
// 產生時已正規化 markdown 硬換行（行尾反斜線）避免顯示成「\ 」。

export interface BlogPost {
  slug: string
  title: string
  date: string // YYYY-MM-DD
  excerpt: string
  paragraphs: string[]
}

export const BLOG_POSTS: BlogPost[] = [
  {
    "slug": "robert-martin-i-dont-review-agent-generated-code",
    "title": "Robert Martin：I don't review code written by agents",
    "date": "2026-07-26",
    "excerpt": "這幾天臉書牆被 Robert Martin 在 X 上的討論洗版",
    "paragraphs": [
      "這幾天臉書牆被 Robert Martin 在 X 上的討論洗版",
      "「I don't review code written by agents.」",
      "改用測試覆蓋率、相依結構、循環複雜度、突變測試這些指標判斷品質，把寫程式碼這件事本身交給 AI Agent",
      "關於這方面的看法與做法，跟我之前閒聊提到以及這幾個月試著在實踐的不謀而合，因為這是個顯而易見的戰略選擇",
      "要真正靠 AI Agent 換到產能，本質上就是要追求人要最大程度的不參與。只要我們還堅持逐行讀完每一段生成的程式碼，在有限的人力資源下，很快就會達到能管理的上限，AI Agent 跑再快再多也沒用，瓶頸永遠是那個要 Review 的人",
      "不過這不代表『從此都不用 Review』，更值得問的是，當初為什麼要 Review Code ?",
      "我們寫一般高階程式語言的時候，通常不會特意去 Review 編譯出來的組合語言。這是因為我們信任編譯器，所以才不特別去看嗎 ? 那要做到什麼程度，我們才算對一個東西建立了真正的信任 ? 那又是什麼時間點我們會覺得需要去看編譯出來的組合語言呢？",
      "以我自己的經驗來說，因為 Shader 的製作工具跟 API 環境比較多元，加上測試階段實際跑到的環境覆蓋率不見得高，做遊戲的過程裡，我們難免還是得看到非常低階的層次，才能搞懂為什麼某個高階 Shader 會在某個硬體環境上跑出錯誤的結果",
      "我們對一個成熟系統的信任，很多時候來自於它被大量使用過、被時間磨過，該炸的地方早就炸過也補過了",
      "再往深一層看，信任其實跟『確定性』 相關，具確定性的結果比較容易讓人信任，所以 AI Agent 產出的程式碼一開始不太被信任，其實非常正常",
      "我們能做的是盡量把『可以變得確定』的部分都變成確定的，至於那些天生不確定的，就靠高頻率或長時間的觀察與驗證去把它收斂。",
      "所以就算最後逃不掉人要參與，也不是用逐行讀完每一段程式碼的方式。某個層次上，要人為驗證的是真正高度重要或脆弱的測試項目，或是具關鍵影響力的程式碼",
      "此外靠 Review 建立信任的方式也不一定真的要 Review Code，像是 Review 工具自動生成的類別圖、狀態圖或序列圖都可以讓我們在不需要逐行閱讀下對於系統增加一定的信任",
      "總而言之，重點大概不是『要不要 Review』，而是『我們的信任到底靠什麼撐住』，怎麼更有效率的建立信任以及這份信任配不配得上這個系統當下所處的狀態"
    ]
  }
]

export function getPost(slug: string): BlogPost | undefined {
  return BLOG_POSTS.find((p) => p.slug === slug)
}
